import React, { useMemo } from 'react';

const buildAddressString = (endereco = {}) => {
  const parts = [
    endereco.RuaLocalizacao,
    endereco.NumeroLocalizacao,
    endereco.BairroLocalizacao,
    endereco.CidadeLocalizacao,
    endereco.EstadoLocalizacao,
    endereco.CEPLocalizacao
  ].filter(Boolean);

  if (!parts.length) {
    return null;
  }

  return parts.join(', ');
};

const EnderecoMap = ({ endereco }) => {
  const enderecoTexto = useMemo(() => buildAddressString(endereco), [endereco]);

  if (!enderecoTexto) {
    return (
      <div className="mt-4 text-muted">
        Informe os dados de endereco para visualizar o mapa.
      </div>
    );
  }

  const mapSrc = `https://www.google.com/maps?q=${encodeURIComponent(enderecoTexto)}&output=embed`;

  return (
    <div className="mt-4">
      <h6 className="mb-2">Localizacao aproximada</h6>
      <div style={{ position: 'relative', width: '100%', paddingBottom: '56.25%', borderRadius: 8, overflow: 'hidden', backgroundColor: '#f5f5f5' }}>
        <iframe
          title="Mapa do endereco"
          src={mapSrc}
          style={{ border: 0, position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
      <div className="mt-2 text-muted small">
        {enderecoTexto}
      </div>
    </div>
  );
};

export default EnderecoMap;
